<!-- eslint-disable max-len -->
<template>
    <div>
      <h2>{{confirmButtonText}} for {{course.className}}</h2>
      <template v-if="price > 0">
        <div style="font-size: 18px;">
          Paying with {{paymentMethod.details.cardType}} ending with {{paymentMethod.details.lastFour}}.
          <span class="changeLink" @click="$emit('change-payment-method')">(Change Payment Method?)</span>
        </div>
        <div style="height: 40px;"/>
        <div class="note-text">
          By clicking "{{confirmButtonText}}" below, you will be charged <span :style="basePriceStyle">{{baseCostString}}</span><span v-if="paymentData.activePrice !== paymentData.basePrice" class="active-cost-label"> {{activeCostString}}</span> immediately.  If you have a coupon code, you may enter it below.
          <coupon-entry
            @coupon-applied="(c)=>$emit('coupon-applied', c)"
            ref="couponEntry"
            :paymentData="paymentData"
            :course="course"
          />
        </div>
      </template>
      <template v-else>
        <div class="note-text">
          By clicking "{{confirmButtonText}}" below, you will use the coupon code "{{paymentData.couponCode}}" to gain access to {{course.className}} for free.  You will not be charged.
        </div>
      </template>
      <button
        style="position: absolute; bottom: 40px; right: 40px; width: 150px; z-index: 1000;"
        :disabled="shouldDisableContinue" class="btn" @click="startPaymentProcess">{{confirmButtonText}}</button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import CouponEntry from '../CouponEntry';

export default {
  components: {
    CouponEntry
  },
  props: {
    course: Object,
    paymentMethod: Object,
    paymentData: Object
  },
  computed: {
    shouldDisableContinue() {
      if (this.haveRefsLoaded && !this.haveRefsLoaded);
      return this.processing || (this.$refs.couponEntry && this.$refs.couponEntry.processing);
    },
    price() {
      return this.paymentData.activePrice;
    },
    basePriceStyle() {
      if (this.paymentData.basePrice !== this.paymentData.activePrice) {
        return 'text-decoration: line-through; color: gray;';
      }
      return 'font-weight: bold;';
    },
    activeCostString() {
      return `$${this.price.toFixed(2)}`;
    },
    baseCostString() {
      return `$${this.paymentData.basePrice.toFixed(2)}`;
    },
    confirmButtonText() {
      if (this.price === 0) {
        return 'Register';
      }
      return 'Confirm Payment';
    }
  },
  data() {
    return {
      haveRefsLoaded: false,
      processing: false
    };
  },
  async mounted() {
    await this.$nextTick();
    this.haveRefsLoaded = !this.haveRefsLoaded;
  },
  methods: {
    ...mapActions([
      'purchaseCourse'
    ]),

    async startPaymentProcess() {
      this.processing = true;
      try {
        const request = {
          classId: this.course._id,
          paymentNonce: this.paymentMethod ? this.paymentMethod.nonce : undefined,
          couponCode:
          (this.paymentData && this.paymentData.isCouponActive)
            ? this.paymentData.couponCode
            : undefined
        };

        await this.purchaseCourse(request);
        this.$emit('payment-success');
      } catch (ex) {
        console.error(ex);
        if (ex.response) {
          // TODO: update alert to use better UX?
          // eslint-disable-next-line no-alert
          alert(ex.response.data);
        }
      }
      this.processing = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.changeLink
{
  transition: 200ms;
  color: #202020;
  font-size: 13px;
  //text-decoration: underline;
}

.changeLink:hover
{
  cursor: pointer;
  color: #606060;
  //text-decoration: underline;
}

.note-text
{
    font-style: italic;
    font-size: 15px;
}

.active-cost-label
{
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/braintree/purchase-flow-views/ConfirmationPage.vue